






import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AppStoresRedirect extends Vue {
  created() {
    if (navigator.userAgent.includes('iPhone')) {
      window.location.replace(
        'https://apps.apple.com/nz/app/dr-log/id1529909486'
      );
    } else if (navigator.userAgent.includes('Android')) {
      window.location.replace(
        'https://play.google.com/store/apps/details?id=com.drlog.dev'
      );
    }
  }
}
